import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const wasteNotificationsRoutes: Routes = [
  {
    path: 'waste-notifications',
    title: 'Notifizierungen',
    loadComponent: () =>
      import('./waste-notifications-list/waste-notifications-list').then(
        m => m.WasteNotificationsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'waste-notifications/new',
    title: 'Neue Notifizierung',
    loadComponent: () =>
      import('./waste-notification-form/waste-notification-form').then(
        m => m.WasteNotificationFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'waste-notifications/:id/edit',
    title: 'Notifizierung bearbeiten',
    loadComponent: () =>
      import('./waste-notification-form/waste-notification-form').then(
        m => m.WasteNotificationFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
